import {
	Card,
	Filters,
	ResourceItem,
	ResourceList,
	TextStyle,
	Thumbnail,
} from "@shopify/polaris"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const SuccessfulUploadsList = (props) => {
	const [products, setProducts] = useState([])
	const [filteredProducts, setFilteredProducts] = useState([])
	const [selectedItems, setSelectedItems] = useState([])
	const [query, setQuery] = useState("")
	const { t } = useTranslation()

	useEffect(() => {
		setProducts(props.successfulUploads)
		setFilteredProducts(props.successfulUploads)
	}, [props.successfulUploads])

	const renderProduct = (product) => {
		const media = (
			<Thumbnail size="large" source={product?.images?.[0]?.src || ""} />
		)

		return (
			<ResourceItem
				id={product.id}
				media={media}
				shortcutActions={[
					{
						content: t("multiple.view_product"),
						onAction: () =>
							window.open(product.url || "", "_blank")?.focus(),
					},
				]}
			>
				<h3 style={{ fontSize: "0.9rem" }}>
					<TextStyle variation="strong">
						{product.title || ""}
					</TextStyle>
				</h3>
				<div style={{ color: "green", fontSize: "0.8rem" }}>
					{t("multiple.successfully_imported")}
				</div>
			</ResourceItem>
		)
	}

	const updateSelected = (e) => {
		setSelectedItems(e)
	}

	const onQueryChange = (change) => {
		setQuery(change)

		if (products.length > 0) {
			const value = change
			let updatedData = []

			if (value.length) {
				updatedData = products.filter((item) => {
					const startsWith = item.title
						.toLowerCase()
						.startsWith(value.toLowerCase())

					const includes = item.title
						.toLowerCase()
						.includes(value.toLowerCase())

					if (startsWith) {
						return startsWith
					} else if (!startsWith && includes) {
						return includes
					} else return null
				})
				setFilteredProducts(updatedData)
			} else {
				setFilteredProducts(products)
			}
		}
	}

	return (
		<>
			<Card>
				<ResourceList
					resourceName={{
						singular: "product",
						plural: "products",
					}}
					items={filteredProducts}
					renderItem={renderProduct}
					filterControl={
						<Filters
							filters={[]}
							queryValue={query}
							onQueryChange={onQueryChange}
							onQueryClear={() => {
								setQuery("")
								setFilteredProducts(products)
							}}
						/>
					}
				/>
			</Card>
		</>
	)
}

export default SuccessfulUploadsList
